export const search = async ({ url, queryParams, additionalParams = {} }) => {
  const response = await fetch(`${url}?${serializeQuery({
    ...additionalParams,
    ...queryParams,
  })}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return await response.json();
};


const serializeQuery = (params, prefix) => {
  const query = Object.keys(params).map((key) => {
    const value = params[key];

    if (params.constructor === Array) key = `${prefix}[]`;
    else if (params.constructor === Object)
      key = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === "object") return serializeQuery(value, key);
    else return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  });

  return [].concat.apply([], query).filter(Boolean).join("&");
};
